const ScrollDetector = {


	toggleBodyClass: () => {
		if (document.documentElement.scrollTop > 0) {
			document.body.classList.add('scrolled')
		} else {
			document.body.classList.remove('scrolled')
		}
	},

	init: () => {

		window.addEventListener('load', () => {

			ScrollDetector.toggleBodyClass()

			document.addEventListener('scroll', (event) => {
				ScrollDetector.toggleBodyClass()
			})
		}, false);
	}
}

ScrollDetector.init()